var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "v-container",
    { staticClass: "text-xs-center", attrs: { fluid: "" } },
    [
      _vm._l(_vm.azioniPossibili, function (azione) {
        return _c(
          "div",
          { key: azione, staticStyle: { margin: "10px" } },
          [
            _c(
              "v-btn",
              {
                attrs: { block: "", color: "primary", disabled: false },
                on: {
                  click: function ($event) {
                    return _vm.eseguiAzione(azione)
                  },
                },
              },
              [
                _vm._v(
                  " " + _vm._s(_vm._f("azioneLavorazioneDesc")(azione)) + " "
                ),
                _c("v-icon", { attrs: { right: "" } }, [
                  _vm._v("mdi-cloud-upload"),
                ]),
              ],
              1
            ),
          ],
          1
        )
      }),
      _c(
        "v-dialog",
        {
          attrs: { "max-width": "80%" },
          model: {
            value: _vm.dialog,
            callback: function ($$v) {
              _vm.dialog = $$v
            },
            expression: "dialog",
          },
        },
        [
          _c(
            "v-card",
            [
              _c("v-card-title", { staticClass: "headline" }, [
                _vm._v(_vm._s(_vm._f("azioneLavorazioneDesc")(_vm.azione))),
              ]),
              _c(
                "Loading",
                {
                  attrs: {
                    visible: _vm.loading,
                    message: "Caricamento dati...",
                  },
                },
                [
                  _c(
                    "v-layout",
                    { attrs: { wrap: "" } },
                    [
                      _c(
                        "v-flex",
                        { attrs: { xs12: "" } },
                        [
                          _vm.negoziazione
                            ? _c(
                                "v-card-text",
                                { staticStyle: { padding: "0 20px" } },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticStyle: {
                                        border: "1px solid gainsboro",
                                        padding: "0 20px",
                                      },
                                    },
                                    [
                                      _c(
                                        "v-menu",
                                        {
                                          ref: "menu1",
                                          attrs: {
                                            lazy: "",
                                            "offset-y": "",
                                            "close-on-content-click": false,
                                            "nudge-right": 40,
                                            transition: "scale-transition",
                                            "max-width": "290px",
                                            "min-width": "90px",
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "activator",
                                                fn: function ({ on }) {
                                                  return [
                                                    _c(
                                                      "v-text-field",
                                                      _vm._g(
                                                        {
                                                          attrs: {
                                                            label:
                                                              "Nuova data proposta",
                                                            "persistent-hint":
                                                              "",
                                                            "prepend-icon":
                                                              "event",
                                                          },
                                                          on: {
                                                            blur: function (
                                                              $event
                                                            ) {
                                                              _vm.date =
                                                                _vm.parseDate(
                                                                  _vm.dateFormatted
                                                                )
                                                            },
                                                          },
                                                          model: {
                                                            value:
                                                              _vm.dateFormatted,
                                                            callback: function (
                                                              $$v
                                                            ) {
                                                              _vm.dateFormatted =
                                                                $$v
                                                            },
                                                            expression:
                                                              "dateFormatted",
                                                          },
                                                        },
                                                        on
                                                      )
                                                    ),
                                                  ]
                                                },
                                              },
                                            ],
                                            null,
                                            false,
                                            484069849
                                          ),
                                          model: {
                                            value: _vm.menu1,
                                            callback: function ($$v) {
                                              _vm.menu1 = $$v
                                            },
                                            expression: "menu1",
                                          },
                                        },
                                        [
                                          _c("v-date-picker", {
                                            attrs: { "no-title": "" },
                                            on: {
                                              input: function ($event) {
                                                _vm.menu1 = false
                                              },
                                            },
                                            model: {
                                              value: _vm.date,
                                              callback: function ($$v) {
                                                _vm.date = $$v
                                              },
                                              expression: "date",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ]
                              )
                            : _vm._e(),
                          _c(
                            "v-card-text",
                            [
                              _c(
                                "v-list",
                                [
                                  _vm._l(_vm.lavorazioni, function (lav, i) {
                                    return [
                                      i > 0
                                        ? _c("v-divider", { key: "d_" + i })
                                        : _vm._e(),
                                      _c(
                                        "v-list-item",
                                        { key: lav.id },
                                        [
                                          _c(
                                            "v-list-item-action",
                                            [
                                              _c("v-checkbox", {
                                                attrs: { value: lav.id },
                                                model: {
                                                  value: _vm.selezione,
                                                  callback: function ($$v) {
                                                    _vm.selezione = $$v
                                                  },
                                                  expression: "selezione",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "v-list-item-content",
                                            [
                                              _c("v-list-item-title", [
                                                _vm._v(
                                                  _vm._s(lav.codiceLAK) +
                                                    ", Modello: " +
                                                    _vm._s(
                                                      lav.modelloDecodificato &&
                                                        lav.modelloDecodificato
                                                          .descrizione
                                                    ) +
                                                    ", Fase: " +
                                                    _vm._s(
                                                      lav.faseDecodificata &&
                                                        lav.faseDecodificata
                                                          .descrizione
                                                    ) +
                                                    ", Lotto: " +
                                                    _vm._s(lav.lotto) +
                                                    ", Consegna: " +
                                                    _vm._s(lav.codiceConsegna) +
                                                    ", Colore: " +
                                                    _vm._s(
                                                      lav.coloreDecodificato &&
                                                        lav.coloreDecodificato
                                                          .descrizione
                                                    )
                                                ),
                                              ]),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ]
                                  }),
                                ],
                                2
                              ),
                            ],
                            1
                          ),
                          _c("v-divider"),
                          _c(
                            "v-card-actions",
                            [
                              _c("v-spacer"),
                              _c(
                                "v-btn",
                                {
                                  attrs: { color: "darken-1", text: "" },
                                  on: {
                                    click: function ($event) {
                                      _vm.dialog = false
                                    },
                                  },
                                },
                                [_vm._v("Annulla")]
                              ),
                              _c(
                                "v-btn",
                                {
                                  attrs: { color: "green darken-1", text: "" },
                                  on: {
                                    click: function ($event) {
                                      $event.stopPropagation()
                                      return _vm.completaAzione.apply(
                                        null,
                                        arguments
                                      )
                                    },
                                  },
                                },
                                [_vm._v("Salva")]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }